module.exports = __webpack_public_path__ + "static/media/menu.05705224.jpg";